import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, PartyPopper } from 'lucide-react';
import { Podium } from './Podium';
import { useAuth } from '../../context/AuthContext';
import { MONO } from './ui';

const API = process.env.REACT_APP_BACKEND_URL;

// Live class ranking for one clip (first attempts only), refreshed every 4s while open.
export const Leaderboard = ({ slug, clipId, t, big, refreshKey, title }) => {
  const { token, user } = useAuth();
  const [podium, setPodium] = useState(false);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!open || !slug) return undefined;
    const load = () => axios.get(`${API}/api/lectures/${slug}/rcount/${clipId}/leaderboard`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 4000);
    return () => clearInterval(id);
  }, [open, slug, clipId, token, refreshKey]);
  return (
    <div data-testid={`leaderboard-${clipId}`}>
      <button onClick={() => setOpen((o) => !o)} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 text-white text-xs font-semibold transition-colors" data-testid={`leaderboard-toggle-${clipId}`}>
        <Trophy className="w-3.5 h-3.5 text-amber-300" />{open ? t.lbHide : t.lbShow}
      </button>
      {open && (
        <div className="mt-2 rounded-xl bg-black/40 border border-white/10 p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[10px] uppercase tracking-[0.2em] text-amber-300 font-bold" style={MONO}>{t.lbTitle}</span>
            <span className="text-[10px] text-blue-100/50" style={MONO} data-testid={`leaderboard-total-${clipId}`}>{data?.total ?? 0} · {t.lbLive}</span>
          </div>
          {!data?.rows?.length ? <p className="text-sm text-blue-100/60">{t.lbEmpty}</p> : (
            <ol className={`space-y-1 ${big ? 'text-2xl' : 'text-sm'}`}>
              {data.rows.map((r, i) => (
                <li key={`${r.name}-${i}`} className={`flex items-center gap-3 rounded-lg px-2 py-1 ${data.my_rank === i + 1 ? 'bg-amber-300/15' : ''}`} data-testid="leaderboard-row">
                  <span className={`w-7 font-extrabold ${i < 3 ? 'text-amber-300' : 'text-blue-100/50'}`} style={MONO}>{i + 1}</span>
                  <span className="flex-1 text-white font-semibold truncate">{r.name}</span>
                  <span className="text-blue-100/60 text-xs" style={MONO}>{r.caught}/{r.real} · {r.taps}×</span>
                  <span className="w-12 text-right font-extrabold text-emerald-300" style={MONO}>{r.score}</span>
                </li>
              ))}
            </ol>
          )}
          {user?.role === 'admin' && data?.rows?.length > 0 && (
            <button onClick={() => setPodium(true)} className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-300 hover:bg-amber-200 text-slate-950 text-sm font-bold transition-colors" data-testid={`podium-open-${clipId}`}>
              <PartyPopper className="w-4 h-4" />{t.podiumOpen}
            </button>
          )}
          {podium && <Podium rows={data.rows.slice(0, 3)} title={title} t={t} onClose={() => setPodium(false)} />}
          {data?.my_rank > 20 && <p className="mt-2 text-xs text-amber-200">{t.lbYou} #{data.my_rank}</p>}
          <p className="mt-2 text-[11px] text-blue-100/50">{t.lbRule}</p>
        </div>
      )}
    </div>
  );
};
